const initTwiCarousel = () => {
  const carousels = document.querySelectorAll('text-with-icons-new');
  
  carousels.forEach(el => {
    const track = el.querySelector('.twi-new__track');
    const btnPrev = el.querySelector('.twi-new__arrow--prev');
    const btnNext = el.querySelector('.twi-new__arrow--next');
    const autoplayMs = parseInt(el.getAttribute('data-autoplay')) || 4000;
    
    let currentIndex = 1; 
    let isTransitioning = false;
    let autoplayInterval = null;

    const addClones = () => {
      if (el.querySelectorAll('.twi-clone').length > 0) return;
      const items = el.querySelectorAll('.twi-new__item:not(.twi-clone)');
      if (items.length < 1) return;
      const firstClone = items[0].cloneNode(true);
      const lastClone = items[items.length - 1].cloneNode(true);
      firstClone.classList.add('twi-clone');
      lastClone.classList.add('twi-clone');
      track.appendChild(firstClone);
      track.insertBefore(lastClone, items[0]);
    };

    const removeClones = () => {
      el.querySelectorAll('.twi-clone').forEach(clone => clone.remove());
    };

    const updatePosition = (animation = true) => {
      if (!el.classList.contains('is-carousel')) return;
      track.style.transition = animation ? 'transform 0.5s ease-in-out' : 'none';
      track.style.transform = `translateX(-${currentIndex * 100}%)`;
    };

    const next = () => {
      if (isTransitioning || !el.classList.contains('is-carousel')) return;
      isTransitioning = true;
      currentIndex++;
      updatePosition();
    };

    const prev = () => {
      if (isTransitioning || !el.classList.contains('is-carousel')) return;
      isTransitioning = true;
      currentIndex--;
      updatePosition();
    };

    track.addEventListener('transitionend', () => {
      isTransitioning = false;
      const items = el.querySelectorAll('.twi-new__item');
      if (currentIndex === items.length - 1) {
        currentIndex = 1;
        updatePosition(false);
      }
      if (currentIndex === 0) {
        currentIndex = items.length - 2;
        updatePosition(false);
      }
    });

    if (btnNext) btnNext.onclick = (e) => { e.preventDefault(); next(); };
    if (btnPrev) btnPrev.onclick = (e) => { e.preventDefault(); prev(); };

    const startAutoplay = () => {
      stopAutoplay();
      autoplayInterval = setInterval(() => {
        if (el.classList.contains('is-carousel')) next();
      }, autoplayMs);
    };

    const stopAutoplay = () => {
      if (autoplayInterval) clearInterval(autoplayInterval);
    };

    const checkLayout = () => {
      const viewport = el.querySelector('.twi-new__viewport');
      const items = el.querySelectorAll('.twi-new__item:not(.twi-clone)');
      
      // Obliczamy szerokość wszystkich elementów razem
      let totalItemsWidth = 0;
      items.forEach(item => {
        totalItemsWidth += item.getBoundingClientRect().width;
      });

      const availableWidth = viewport.offsetWidth;

      // Jeśli elementy zajmują więcej niż 90% miejsca lub ekran jest mały (< 768px)
      if (totalItemsWidth > availableWidth * 0.9 || window.innerWidth < 768) {
        if (!el.classList.contains('is-carousel')) {
          el.classList.add('is-carousel');
          addClones();
          currentIndex = 1;
          updatePosition(false);
          startAutoplay();
        }
      } else {
        el.classList.remove('is-carousel');
        stopAutoplay();
        removeClones();
        track.style.transform = 'none';
        track.style.transition = 'none';
      }
    };

    window.addEventListener('resize', checkLayout);
    // Małe opóźnienie, aby upewnić się, że style CSS się załadowały
    setTimeout(checkLayout, 100);
  });
};

document.addEventListener('DOMContentLoaded', initTwiCarousel);
document.addEventListener('shopify:section:load', initTwiCarousel);